<div class="individual-bank-account-verification">
    <div class="form-group">
      <label for="initials" class="fw-bold text-xs">Initials</label>
      <input type="text" v-model="form.initials" id="initials" class="form-control text-xs rounded-small p-3 shadow-sm" required />
      <small v-if="error_messages.initials" class="form-text text-danger text-xs fw-bold">
        {{ error_messages.initials }}
      </small>
    </div>
    <div class="form-group">
      <label for="surname" class="fw-bold text-xs">Surname</label>
      <input type="text" v-model="form.surname" id="surname" class="form-control text-xs rounded-small p-3 shadow-sm" required />
      <small v-if="error_messages.surname" class="form-text text-danger text-xs fw-bold">
        {{ error_messages.surname }}
      </small>
    </div>
    <div class="form-group">
      <label for="id_number" class="fw-bold text-xs">ID Number</label>
      <input type="text" v-model="form.id_number" id="id_number" class="form-control text-xs rounded-small p-3 shadow-sm" maxlength="13" required />
      <small v-if="error_messages.id_number" class="form-text text-danger text-xs fw-bold">
        {{ error_messages.id_number }}
      </small>
    </div>
    <div class="form-group">
      <label for="id_type" class="fw-bold text-xs">ID Type</label>
      <select v-model="form.id_type" id="id_type" class="form-select text-xs rounded-small p-3 shadow-sm" required>
        <option value="" disabled hidden>Select ID Type</option>
        <option v-for="id_type in id_types" :key="id_type.id" :value="id_type.id_type">
          {{ id_type.id_type }}: {{ id_type.description }}
        </option>
      </select>
      <small v-if="error_messages.id_type" class="form-text text-danger text-xs fw-bold">
        {{ error_messages.id_type }}
      </small>
    </div>
    <div class="form-group">
      <label for="bank_name" class="fw-bold text-xs">Bank Name</label>
      <select v-model="form.bank_name" id="bank_name" class="form-select text-xs rounded-small p-3 shadow-sm" required>
        <option value="" disabled hidden>Select Bank</option>
        <option v-for="bank in banks" :key="bank.id" :value="bank.name">
          {{ bank.name }}
        </option>
      </select>
      <small v-if="error_messages.bank_name" class="form-text text-danger text-xs fw-bold">
        {{ error_messages.bank_name }}
      </small>
    </div>
    <div class="form-group">
      <label for="branch_code" class="fw-bold text-xs">Branch Code</label>
      <input type="text" v-model="form.branch_code" id="branch_code" class="form-control text-xs rounded-small p-3 shadow-sm" required />
      <small v-if="error_messages.branch_code" class="form-text text-danger text-xs fw-bold">
        {{ error_messages.branch_code }}
      </small>
    </div>
    <div class="form-group">
      <label for="account_type" class="fw-bold text-xs">Account Type</label>
      <select v-model="form.account_type" id="account_type" class="form-select text-xs rounded-small p-3 shadow-sm" required>
        <option value="" disabled hidden>Select Account Type</option>
        <option v-for="account_type in account_types" :key="account_type.id" :value="account_type.name">
          {{ account_type.name }}
        </option>
      </select>
      <small v-if="error_messages.account_type" class="form-text text-danger text-xs fw-bold">
        {{ error_messages.account_type }}
      </small>
    </div>
    <div class="form-group">
      <label for="account_number" class="fw-bold text-xs">Account Number</label>
      <input type="text" v-model="form.account_number" id="account_number" class="form-control text-xs rounded-small p-3 shadow-sm" required />
      <small v-if="error_messages.account_number" class="form-text text-danger text-xs fw-bold">
        {{ error_messages.account_number }}
      </small>
    </div>
    <div class="d-flex justify-content-end my-2">
        <button @click="handle_submit" class="btn btn-primary-color rounded-pill text-xs">
            Run Service
        </button>
    </div>
</div>
